import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0feb063b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-12 text-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left text-primary" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card shadow-sm mb-5" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title text-gray-800" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1))
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  class: "fs-4 text-gray-700",
  style: {"white-space":"pre-line"}
}
const _hoisted_11 = {
  key: 0,
  class: "card shadow-sm mb-5"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  class: "w-100",
  style: {"height":"500px"}
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "row gx-5 mb-5 order-1"
}
const _hoisted_16 = { class: "col-lg-12" }
const _hoisted_17 = { class: "card card-xl-stretch" }
const _hoisted_18 = { class: "card-header" }
const _hoisted_19 = { class: "card-title text-gray-800" }
const _hoisted_20 = { class: "card-toolbar" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-history text-primary" }, null, -1))
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "fs-4 text-gray-700" }
const _hoisted_25 = { class: "card-footer" }
const _hoisted_26 = { class: "d-flex flex-center justify-content-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "row d-inline-flex justify-content-around text-gray-500" }
const _hoisted_29 = { class: "col px-0 mx-2" }
const _hoisted_30 = { class: "text-gray-700" }
const _hoisted_31 = {
  id: "days",
  class: "number fw-bold"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col px-0 mx-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white-opacity" }, "."),
  /*#__PURE__*/_createElementVNode("div", {
    id: "days",
    class: "number"
  }, ":")
], -1))
const _hoisted_33 = { class: "col px-0 mx-2" }
const _hoisted_34 = { class: "text-gray-700" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "hours",
  class: "number fw-bold"
}, " 00 ", -1))
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"col px-0 mx-2\" data-v-0feb063b><p class=\"text-white-opacity\" data-v-0feb063b>.</p><div id=\"days\" class=\"number\" data-v-0feb063b>:</div></div><div class=\"col px-0 mx-2\" data-v-0feb063b><p class=\"text-gray-700\" data-v-0feb063b>Min</p><div id=\"minutes\" class=\"number fw-bold\" data-v-0feb063b> 00 </div></div><div class=\"col px-0 mx-2\" data-v-0feb063b><p class=\"text-white-opacity\" data-v-0feb063b>.</p><div id=\"days\" class=\"number\" data-v-0feb063b>:</div></div><div class=\"col px-0 mx-2\" data-v-0feb063b><p class=\"text-gray-700\" data-v-0feb063b>Seg</p><div id=\"seconds\" class=\"number fw-bold\" data-v-0feb063b> 00 </div></div>", 4)
const _hoisted_40 = {
  key: 2,
  class: "row d-flex justify-content-center"
}
const _hoisted_41 = {
  class: "card shadow-sm w-full",
  style: {"height":"613px"}
}
const _hoisted_42 = { class: "card-body" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "container text-center mt-5" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_46 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }
const _hoisted_47 = {
  key: 1,
  class: "d-flex flex-column py-6"
}
const _hoisted_48 = { class: "container text-center mt-5" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_50 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import moment from "moment/moment";
import ApiService from "@/core/services/ApiService";
import { useCertificationSteps } from "@/core/composables/useCertificationSteps";
import { useCertificationExecution } from "@/core/composables/useCertificationExecution";
import { formatBrasilia } from "@/core/helpers/dates";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



const store = useStore();
const router = useRouter();

// Composable para gerenciar steps da certificação
const {
  loading: configLoading,
  strategyType,
  currentStep,
  steps,
  expectedStepForComponent,
  isOnCorrectStep,
  getNextStepRoute,
  loadCertificationData,
  configData,
  getStepByType,
} = useCertificationSteps(props.id, 'certification_to_do_start');

const stepTitle = computed(() => null);
const welcomeMessage = computed(() => configData.value?.welcome_message?.trim() || null);

const currentUser = computed(() => store.getters.currentUser);
const videoUrl = computed(() => {
  const raw = configData.value?.video_url;
  if (!raw) return null;
  if (raw.includes('gumlet.io')) {
    const nick = currentUser.value?.nick || 'No nick';
    const email = currentUser.value?.email || '';
    const sep = raw.includes('?') ? '&' : '?';
    return `${raw}${sep}watermark_text=${encodeURIComponent(`${nick} - ${email}`)}`;
  }
  return raw;
});

// Composable para lógica de execução compartilhada
const {
  deadline,
  created_at,
  fetchDeadline,
} = useCertificationExecution(props.id);

const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const showCountdown = ref(false);
const loading = ref(false);

// Computed para combinar loading states
const isLoading = computed(() => loading.value || configLoading.value);

const getDeadline = async () => {
  try {
    showCountdown.value = false;
    const statusData = await fetchDeadline();
    
    if (statusData) {
      // Verifica se está no step esperado para este componente
      if (statusData.current_step !== expectedStepForComponent.value) {
        console.log('Usuário não está no step correto para esta view');
      }
    }
  } catch (e) {
    console.error("Erro ao buscar o deadline:", e);
    if (e.response?.data?.message === "certificado ainda não iniciado") {
      await router.push({ name: 'certifications' });
    }
  } finally {
    showCountdown.value = true;
  }
};

onMounted(async () => {
  loading.value = true;
  try {
    // Carrega configuração e status da certificação
    await loadCertificationData();
    
    // Depois carrega os dados específicos desta view
    await getDeadline();
  } catch (e) {
    console.error('Erro ao carregar dados:', e);
    await router.push({ name: 'certifications' });
  } finally {
    loading.value = false;
  }
});

const formatDate = (date: string) => formatBrasilia(date);

// Computed para somar todos os deadline_days dos steps
const totalDeadlineDays = computed(() => {
  if (!steps.value || steps.value.length === 0) return 7; // fallback
  
  const total = steps.value
    .filter(step => step.deadline_days !== undefined && step.deadline_days !== null)
    .reduce((sum, step) => sum + (step.deadline_days || 0), 0);
  
  return total > 0 ? total : 7; // fallback se nenhum step tiver deadline
});

// Computed para calcular a data final projetada baseada no created_at + total de dias
const projectedEndDate = computed(() => {
  if (!created_at.value) return '';

  const end = moment.utc(created_at.value).add(totalDeadlineDays.value, 'days').toISOString();
  return formatBrasilia(end);
});

// Computed para formatar o texto de dias (singular/plural)
const deadlineDaysText = computed(() => {
  const days = totalDeadlineDays.value;
  return days === 1 ? `${days} dia corrido` : `${days} dias corridos`;
});

const handlerStartDeadline = async () => {
  
  try {
    loading.value = true;
    
    // 1. Iniciar deadline
    const startResponse = await ApiService.get(`/certification/start-deadline/${props.id}`);
    
    if (startResponse.data.success) {
      // 2. Avançar step
      await ApiService.post(`/certification/${props.id}/advance-step`);
      
      // 3. Redirecionar para próximo step
      const nextRoute = getNextStepRoute();
      if (nextRoute) {
        await router.push({ name: nextRoute, params: { id: props.id } });
      } else {
        await router.push({ name: 'certifications' });
      }
    }
  } catch (e) {
    console.error('Erro ao iniciar certificação:', e);
  } finally {
    loading.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'certifications' },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.back`)), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (!_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(stepTitle) ?? _ctx.$t(`${_unref(currentLanguage)}.certification.to_do.title`)), 1),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(welcomeMessage) ?? _ctx.$t(`${_unref(currentLanguage)}.certification.to_do.description`)), 1)
            ])
          ]),
          (_unref(videoUrl))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("iframe", {
                      style: {"width":"100%","height":"100%","border-radius":"10px"},
                      src: _unref(videoUrl),
                      frameborder: "0",
                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_14)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (showCountdown.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline`)), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", {
                          onClick: handlerStartDeadline,
                          class: "btn btn-sm btn-light-primary text-primary text-hover-white"
                        }, [
                          _hoisted_21,
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.start_challenge`)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("p", _hoisted_24, [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_1`)) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_unref(created_at) === undefined ? '00/00/0000 00:00' : formatDate(_unref(created_at))) + "h", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_2`)) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_unref(projectedEndDate) || '00/00/0000 00:00') + "h", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_3`)) + " ", 1),
                        _createElementVNode("b", null, _toDisplayString(_unref(deadlineDaysText)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.deadline_desc_4`)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.day`)), 1),
                              _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(totalDeadlineDays).toString().padStart(2, '0')), 1)
                            ]),
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hours`)), 1),
                              _hoisted_35
                            ]),
                            _hoisted_36
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("span", _hoisted_46, "   " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.to_do.analyzing_machines_and_calculating_time`)) + "...", 1)
                      ])
                    ])
                  ])
                ])
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("span", _hoisted_50, "   " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.certification.index.analyzing_the_requirements`)) + "...", 1)
          ])
        ]))
  ], 64))
}
}

})